import i18n from 'src/lib/i18n/i18n';

/**
 * Age consent checkbox.
 */
export function AgeConsent({
  onChange,
}: {
  onChange: (selected: boolean) => void;
}) {
  return (
    <div class="ageConsentContainer">
      <input
        type="checkbox"
        id="ageConsent"
        className="ageConsentCheckbox"
        defaultChecked={true}
        onChange={(e) => {
          onChange((e.target as HTMLInputElement).checked);
        }}
      />
      <label
        for="ageConsent"
        dangerouslySetInnerHTML={{
          __html: i18n('komojuHostedFields.ageConfirm'),
        }}
      />
    </div>
  );
}
